import { render, staticRenderFns } from "./BaseConfirmDeletionModal.vue?vue&type=template&id=2e68f3d8"
import script from "./BaseConfirmDeletionModal.vue?vue&type=script&lang=js"
export * from "./BaseConfirmDeletionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports